export default "__VITE_ASSET__DJaYMfsT__"